import { Component, Inject, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PartyPEPsRecord } from '../../interfaces/party-peps-records/party-peps-record';
import { PartySanctionRecord } from '../../interfaces/party-sanction-records/party-sanction-record';
import { Party } from '../../interfaces/parties/party';
import { ePepsAndSanctionListGroup } from '../../enums';
import { FullCountryNamePipe } from '../../country-full-name-pipe';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'lib-party-peps-and-sanctions-dialog',
    templateUrl: './party-peps-and-sanctions-dialog.component.html',
    styleUrl: './party-peps-and-sanctions-dialog.component.css',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [FullCountryNamePipe]
})
export class PartyPepsAndSanctionsDialogComponent {
  private readonly transloco = inject(TranslocoService);
  recordType: string = '';
  pepsRecords: PartyPEPsRecord[] = [];
  sanctionRecords: PartySanctionRecord[] = [];
  secondarySanctionRecords: PartySanctionRecord[] = [];

  sanctionsColumns: string[] = ['name-on-record', 'alternate-names', 'authority', 'country', 'list', 'date', 'currency-date', 'view'];
  secondarySanctionsColumns: string[] = ['name-on-record', 'alternate-names', 'authority', 'country', 'list', 'date', 'currency-date', 'view'];
  pepsColumns: string[] = ['name-on-record', 'alternate-names', 'position', 'category', 'end-date', 'currency-date', 'view'];

  expandedItem: PartyPEPsRecord | PartySanctionRecord | null = null;
  fullDetails: any | null = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: Party,
    private fullCountryNamePipe: FullCountryNamePipe) {
    this.pepsRecords = data.pepRecords ?? [];
    this.sanctionRecords = data.sanctionRecords?.filter(r => r.listGroup == ePepsAndSanctionListGroup.Primary) ?? [];
    this.secondarySanctionRecords = data.sanctionRecords?.filter(r => r.listGroup == ePepsAndSanctionListGroup.Secondary) ?? [];
  }

  viewDetails(record: PartyPEPsRecord | PartySanctionRecord) {
    this.expandedItem = record;
    this.recordType = this.isPep(record) ? this.transloco.translate('partyPepsDialog.pepRecordDetails') : this.transloco.translate('partyPepsDialog.sanctionsRecordDetails');
    this.fullDetails = JSON.parse(record.fullRecord);
  }

  isPep(record: PartyPEPsRecord | PartySanctionRecord) {
    return (record as PartyPEPsRecord).position !== undefined;
  }

  exitDetails() {
    this.expandedItem = null;
  }

  downloadDetails() {
    const documentType = `application/json`;
    const blob = new Blob([JSON.stringify(this.fullDetails)], { type: documentType });
    const blobURL = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobURL;
    link.download = `${this.expandedItem?.nameOnRecord}.json`; // set a name for the file
    link.click();
  }

  getCountryFull(country: string): string {
    if (country === '') return this.transloco.translate('common.labels.unknown');

    return this.fullCountryNamePipe.transform(country);
  }
}
